import {Component, Input} from '@angular/core';
import {FilterOperations, IFilter, IFilterGroup} from '../../../../../features/settings-new/models/general/advanced-filter-group.interface';
import {countDirectFilterConditions} from '../../../../../features/settings-new/models/general/advanced-filters.utils';
import {ColDef} from 'ag-grid-community';
import {Store} from '@ngrx/store';
import {
  addFilterAndGroupToSelectedAdvancedFilterGroup,
  addFilterToSelectedAdvancedFilterGroup,
  addGroupToSelectedAdvancedFilterGroup,
  deleteAdvancedFilterGroupGroup,
  setSelectedAdvancedFilterGroupOperator,
} from '../../../../../features/core/store-shared-filter/shared-filter.actions';

@Component({
  selector: 'app-shared-modal-filters-advanced-group',
  templateUrl: './shared-modal-filters-advanced-group.component.html',
  styleUrls: ['./shared-modal-filters-advanced-group.component.scss'],
  standalone: false,
})
export class SharedModalFiltersAdvancedGroupComponent {

  colDefs: ColDef[];
  filterGroup: IFilterGroup;
  fgOperator: FilterOperations;

  @Input() allowDeleteTopLevel = false;
  @Input() depth = 0;
  @Input() isTopLevelGroup = false;
  @Input() predecessorID: number;

  constructor(
    private readonly store: Store,
  ) {
  }

  @Input() set setColDef(colDefs: ColDef[]) {
    this.colDefs = colDefs;
  }

  @Input() set setFilterGroups(fgInput: IFilterGroup | IFilter) {
    const filterGroup = fgInput as IFilterGroup;
    if (filterGroup) {
      this.filterGroup = filterGroup;
      this.fgOperator = filterGroup.operator;
      this.sortFilterGroups();
    }
  }

  getObjectHasProperty(obj: IFilter | IFilterGroup, property: string): boolean {
    return obj.hasOwnProperty(property);
  }

  canRemoveCondition(filter: IFilter | IFilterGroup): boolean {
    if ('operator' in filter) {
      return true;
    }
    return countDirectFilterConditions(this.filterGroup) > 1;
  }

  onAddFilterClick(): void {
    if (!this.filterGroup?.filtersAndGroups) {
      this.store.dispatch(addFilterAndGroupToSelectedAdvancedFilterGroup({
        predecessorID: this.predecessorID,
        shouldAddFilter: true,
      }));
    } else {
      this.store.dispatch(addFilterToSelectedAdvancedFilterGroup({
        predecessorID: this.predecessorID,
      }));
    }
  }

  onAddGroupClick(): void {
    this.store.dispatch(addGroupToSelectedAdvancedFilterGroup({
      predecessorID: this.predecessorID,
    }));
  }

  onDeleteItemClick(): void {
    this.store.dispatch(deleteAdvancedFilterGroupGroup({filterGroup: this.filterGroup}));
  }

  onToggleOperator(operator: FilterOperations): void {
    this.store.dispatch(setSelectedAdvancedFilterGroupOperator({operator, filterGroupId: this.filterGroup.id}));
  }

  private sortFilterGroups(): void {
    const filters: IFilter[] = [];
    const groups: IFilterGroup[] = [];
    this.filterGroup?.filtersAndGroups?.forEach((item: IFilter | IFilterGroup) => {
      if (item.hasOwnProperty('operator')) {
        groups.push(item as IFilterGroup);
      } else {
        filters.push(item as IFilter);
      }
    });
    this.filterGroup = {
      id: this.filterGroup.id,
      operator: this.filterGroup.operator,
      filtersAndGroups: [...filters, ...groups],
    };
  }

}
